'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Select time'
};
exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/en_US.js
// module id = 110
// module chunks = 35783957827783 65974612472484